module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: -exh0NxeEio\n\n## Notes\nEsmeralda gives the Apprentices their first mission (1:28).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level1_closing.md
// module id = 1860
// module chunks = 2